import { FormSearchableSelect } from '../../../..';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { FormSearchableSelectProps } from '../../../form/fields/searchableSelect';

type FormTaxClassSelectProps = Omit<FormSearchableSelectProps, 'options'> & { options?: number[] };

export const FormTaxClassSelect: FC<FormTaxClassSelectProps> = (props) => {
  const { t } = useTranslation();

  const steuerklassenOptions = (props.options ?? [1, 2, 3, 4, 5, 6]).map((i) => {
    return {
      text: t('employee:STEUERKLASSE_NAME', { class: i }),
      value: i
    };
  });

  return (
    <FormSearchableSelect
      {...props}
      label={t('employee:STEUERKLASSE')}
      placeholder={t('employee:STEUERKLASSE')}
      options={steuerklassenOptions}
    />
  );
};
